// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { ScoreFragmentDoc } from './ScoreFragment';
export type TournamentFragment = { id: string, enabled: boolean | undefined, openAt: any, closeAt: any, iAmOptedIn: boolean | undefined, name: string | undefined, prizeText: string | undefined, activityType: string | undefined, shortUrl: string | undefined, backgroundImageSmall: string | undefined, backgroundImageLarge: string | undefined, rules: string | undefined, leaderboardType: string | undefined, myScore: { id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined, leaderboardAfter: Array<{ id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined } | undefined> | undefined, leaderboardBefore: Array<{ id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined } | undefined> | undefined } | undefined, prizes: Array<{ id: string, forPosition: number | undefined, name: string | undefined, link: string | undefined, automaticallyReleased: boolean | undefined } | undefined> | undefined, leaderboard: Array<{ id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined } | undefined> | undefined };

export type TournamentPrizeFragment = { id: string, forPosition: number | undefined, name: string | undefined, link: string | undefined, automaticallyReleased: boolean | undefined };

export type MyScoreFragment = { id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined, leaderboardAfter: Array<{ id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined } | undefined> | undefined, leaderboardBefore: Array<{ id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined } | undefined> | undefined };

export const MyScoreFragmentDoc = gql`
    fragment MyScore on CasinoTournamentsPublicScore {
  ...ScoreFragment
  leaderboardAfter {
    ...ScoreFragment
  }
  leaderboardBefore {
    ...ScoreFragment
  }
}
    ${ScoreFragmentDoc}`;
export const TournamentPrizeFragmentDoc = gql`
    fragment TournamentPrize on CasinoTournamentsPublicPrize {
  id
  forPosition
  name
  link
  automaticallyReleased
}
    `;
export const TournamentFragmentDoc = gql`
    fragment TournamentFragment on CasinoTournamentsPublicTournament {
  id
  enabled
  openAt
  closeAt
  iAmOptedIn
  name
  prizeText
  activityType
  shortUrl
  backgroundImageSmall
  backgroundImageLarge
  rules
  myScore {
    ...MyScore
  }
  prizes {
    ...TournamentPrize
  }
  leaderboardType
  leaderboard {
    id
    username
    points
    position
    isMyScore
    canClaimPrize
  }
}
    ${MyScoreFragmentDoc}
${TournamentPrizeFragmentDoc}`;